export const GOOGLE_MAP_KEY = 'AIzaSyAaj6jBUVBBXVRT5sRq-oSL5hTy83Z3Jaw';


// WEBPACK FOOTER //
// ./src/constants/consttants.ts